import { MAT_DIALOG_DEFAULT_OPTIONS, type MatDialogConfig } from '@angular/material/dialog';
import type { Provider } from '@angular/core';

export const defaultMatDialogProvider: Provider = {
  provide: MAT_DIALOG_DEFAULT_OPTIONS,
  useValue: {
    closeOnNavigation: true,
    disableClose: true,
    hasBackdrop: true,
    autoFocus: true,
    restoreFocus: true,
  } satisfies MatDialogConfig,
};
